import JsPDF from 'jspdf'
import 'jspdf-autotable'
import HtmlToCanvas from 'html2canvas'
import moment from 'moment'

export default {
  Tabela: async (nomeRelatorio, info, orientation) => {
    moment.locale()
    var time = moment().format('LLL')
    var logoMilkPlan = new Image()
    logoMilkPlan.src = 'img/logo-pdf.png'

    var doc = new JsPDF({orientation, compress: 'true'})
    var pageSize = doc.internal.pageSize
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

    doc.addImage(
      logoMilkPlan,
      'PNG',
      pageWidth - 25,
      10,
      15,
      10,
      'LogoMilkPlan',
    )
    doc.setFontSize(16)
    doc.text(nomeRelatorio, 9.7, 15)

    doc.setFontSize(10)

    HtmlToCanvas(document.querySelector(info)).then(canvas => {
      var dataURL = canvas.toDataURL()
      doc.addImage(
        dataURL,
        'JPEG',
        5,
        25,
        pageWidth - 30,
        pageSize.height - 50,
        '',
        'SLOW',
      )
      doc.save(nomeRelatorio + '-' + time + '.pdf')
    })
  },
}
